<ion-header>
  <ion-toolbar>
    <ion-title>Agregar dirección</ion-title>
    <ion-buttons slot="end">
        <ion-button color="dark" (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- FORM -->
  <div class="formContainer reverseFlex">
    <app-form [questions]="addressQuestions" (submit)="addAddress()"></app-form>
    <button class="z-depth-2 smallButton" (click)="addAddress()">AGREGAR</button>
  </div>
</ion-content>
